import { makeQuery } from "utilities/makeQuery"
import { fetchApiJson } from "utilities/fetchApiJson"

/**
 * 
 * @param {{page?: number, perPage?: number, category?: string}} params 
 * @returns 
 */
export async function getCategoryArchiveWinsAndReviewsApi(params) {
  return await fetchApiJson(makeQuery('/api/category-archive-wins-reviews', params))
}
